import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Instagram, MessageCircle, Menu, X } from 'lucide-react';
import { salonInfo } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Products', path: '/products' },
    { name: 'Offers & New', path: '/offers' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24 md:h-28">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/posh-logo.png" 
              alt="Posh Signature Beauty Salon" 
              className="h-16 w-auto md:h-20 lg:h-24 object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-gray-700 hover:text-amber-600 font-bold transition-colors duration-200 text-sm whitespace-nowrap"
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Quick Contact Icons */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href={`tel:${salonInfo.phone}`}
              className="p-2 text-gray-700 hover:text-amber-600 hover:bg-amber-50 rounded-full transition-all duration-200"
              aria-label="Call us"
            >
              <Phone className="w-5 h-5" />
            </a>
            <a
              href={`https://wa.me/${salonInfo.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-700 hover:text-amber-600 hover:bg-amber-50 rounded-full transition-all duration-200"
              aria-label="WhatsApp"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
            <a
              href={salonInfo.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-gray-700 hover:text-amber-600 hover:bg-amber-50 rounded-full transition-all duration-200"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <Link
              to="/booking"
              className="ml-4 px-6 py-2 bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-all duration-200 font-medium"
            >
              Book Now
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block py-2 text-gray-700 hover:text-amber-600 font-medium transition-colors duration-200"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/booking"
              className="block w-full text-center px-6 py-3 bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-all duration-200 font-medium mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              Book Now
            </Link>
          </nav>
          <div className="flex justify-center items-center space-x-6 px-4 pb-4">
            <a href={`tel:${salonInfo.phone}`} className="text-gray-700 hover:text-amber-600">
              <Phone className="w-5 h-5" />
            </a>
            <a href={`https://wa.me/${salonInfo.whatsapp}`} className="text-gray-700 hover:text-amber-600">
              <MessageCircle className="w-5 h-5" />
            </a>
            <a href={salonInfo.social.instagram} className="text-gray-700 hover:text-amber-600">
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
